"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _react = _interopRequireWildcard(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function DrawerTrigger(a) {
  var b = a.children,
      c = a.drawerRef;
  if (!c) return "function" == typeof b ? b({}) : b;
  var d = c.current || c;
  return "function" == typeof b ? b({
    onClick: d.toggleMinimiseState
  }) : _react["default"].cloneElement(b, {
    onClick: d.toggleMinimiseState
  });
}

var _default = (0, _react.memo)(DrawerTrigger);

exports["default"] = _default;